import exp from "constants";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IChungChiSinhVienReducer } from "../../reducer-model/xet-chung-chi/IChungChiSinhVienReducer";
import { IChungChiSinhVienActionTypes } from "../../action-types/xet-chung-chi/IChungChiSinhVienActions";

const iniState : IChungChiSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    processId: undefined,
    isShowProcessing: false,
    chungChiSinhVienDats: [],
    chungChiSinhVienKhongDats: [],
    filterTongHopChungChi: {
        selectedTrangThaiHocs: [0],
        treeViewLopFocusedValue: undefined,
    },
};

export const chungChiSinhVienReducer = (state: IChungChiSinhVienReducer = iniState, action: IChungChiSinhVienActionTypes): IChungChiSinhVienReducer => {
    switch (action.type) {
        case "CHUNG_CHI_SINH_VIEN_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chungChiSinhVienDats: action.payload,
            };
        case "CHUNG_CHI_SINH_VIEN_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_LOAD_KHONG_DAT_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_LOAD_KHONG_DAT_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chungChiSinhVienKhongDats: action.payload,
            };
        case "CHUNG_CHI_SINH_VIEN_LOAD_KHONG_DAT_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                isShowProcessing: true,
                processId: action.payload?.process_id || undefined,
            };
        case "CHUNG_CHI_SINH_VIEN_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_SINH_VIEN_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_HIEU_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_HIEU_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_HIEU_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_VAO_SO_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_VAO_SO_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_SO_VAO_SO_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        
          case "CHUNG_CHI_SINH_VIEN_UPDATE_QUYET_DINH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_QUYET_DINH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_SINH_VIEN_UPDATE_QUYET_DINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_SINH_VIEN_DU_DIEU_KIEN_CHANGE_SELECTED_IDS":
            return {
                ...state,
                sinhVienDuDieuKienSelectedIds: action.payload,
            };
        case "CHUNG_CHI_SINH_VIEN_SHOW_CAU_HINH_SO_VAO_SO_MODAL":
            return {
                ...state,
                isShowCauHinhSoVaoSoModal: true,
            };
        case "CHUNG_CHI_SINH_VIEN_CLOSE_CAU_HINH_SO_VAO_SO_MODAL":
            return {
                ...state,
                isShowCauHinhSoVaoSoModal: false,
            };
        case "CHUNG_CHI_SINH_VIEN_SHOW_CAU_HINH_SO_HIEU_MODAL":
            return {
                ...state,
                isShowCauHinhSoHieuModal: true,
            };
        case "CHUNG_CHI_SINH_VIEN_CLOSE_CAU_HINH_SO_HIEU_MODAL":
            return {
                ...state,
                isShowCauHinhSoHieuModal: false,
            };
        case "CHUNG_CHI_SINH_VIEN_SHOW_CAU_HINH_SO_QUYET_DINH_MODAL":
            
            return {
                ...state,
                isShowCauHinhSoQuyetDinhModal: true,
            };
        case "CHUNG_CHI_SINH_VIEN_CLOSE_CAU_HINH_SO_QUYET_DINH_MODAL":
            return {
                ...state,
                isShowCauHinhSoQuyetDinhModal: false,
            };

        case "CHUNG_CHI_SINH_VIEN_SELECT_TONG_HOP_BY_LOP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_SINH_VIEN_SELECT_TONG_HOP_BY_LOP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tongHopChungChi: action.payload,
            };
        case "CHUNG_CHI_SINH_VIEN_SELECT_TONG_HOP_BY_LOP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_SINH_VIEN_UPLOAD_MODAL_OPEN":
            return {
                ...state,
                importModal: {
                    isShow: true,
                    id_dot_xet: action.payload,
                },
            };
        case "CHUNG_CHI_SINH_VIEN_UPLOAD_MODAL_CLOSE":
            return {
                ...state,
                importModal: {
                    isShow: false,
                    id_dot_xet: 0,
                },
            };
        case "CHUNG_CHI_SINH_VIEN_CHANGE_FILTER_TONG_HOP_CHUNG_CHI":
            return {
                ...state,
                filterTongHopChungChi: action.payload,
            };
        default:
            return state;
    }
}